<template>
  <span>
    <side-bar></side-bar>
    <router-view></router-view>
  </span>
</template>
<script>
import { mapState } from "vuex";
import SideBar from "./../layouts/sideBarDash.vue";
export default {
  name: "",
  components: {
    SideBar,
  },
  created() {},
  data() {
    return {};
  },
  computed: {
    ...mapState,
  },
  methods: {},
};
</script>